<hazmatsuite-next-stepper
  [async]="false"
  [steps]="(stepperItems$ | async) || []"
  (selectStep)="selectStep($event)"
></hazmatsuite-next-stepper>

<ng-container *ngIf="previewResult$ | async as previewResult">
  <div id="ch-ggs-web-suite-content">
    <div class="container">
      <ng-container
        *ngIf="easyDgdCommonResource$ | async as easyDgdCommonResource"
      >
        <h1>{{ easyDgdCommonResource['StepPreview'] }}</h1>
      </ng-container>
      <div class="row">
        <div class="col-md-8 col-lg-8">
          <img
            *ngIf="previewResult!.Base64Image"
            [src]="previewResult!.Base64Image"
            class="easydgd-preview-image"
          />
        </div>
        <div class="col-md-4 col-lg-4">
          <ng-container *ngIf="layoutResource$ | async as layoutResource">
            <ng-container *ngIf="downloadResource$ | async as downloadResource">
              <hazmatsuite-next-payment-summary
                [model]="{
                  InformationTitle: downloadResource['InformationTitle'],
                  InformationText: downloadResource['InformationText'],

                  LicenseDependentButtonModel: licenseDependentButtonModel
                }"
                (submitAction)="buyDocument($event)"
              ></hazmatsuite-next-payment-summary>
            </ng-container>
          </ng-container>
        </div>
        <div id="dgd-form-navigation">
          <form [formGroup]="form">
            <easydgd-footer-navigation-buttons
              [hideNext]="true"
            ></easydgd-footer-navigation-buttons>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-container>
